import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpinModelServiceService } from "./spin-model-service.service";
import { EditComponent } from './../edit/edit.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-spin-view',
  templateUrl: './spin-view.component.html',
  styleUrls: ['./spin-view.component.css'],
  providers: []
})
export class SpinViewComponent implements OnInit {
  @ViewChild("content") content;
  tower : string;
  role;
  view : string;
  imageData = [];
  prevDir;
  crntDir;
  index;
  sliderIndex;
  loaded;
  result;
  data;
  dirValue;
  loading;
  constructor(private dialog: MatDialog,private route: ActivatedRoute,private service : SpinModelServiceService, private renderer : Renderer2, private snackBar: MatSnackBar, private router: Router) {
    this.loading = false;
    this.crntDir = 0;
    this.index = 0;
    this.prevDir = 0;
    this.sliderIndex = false;
    this.loaded = false;
  if (this.router.url.search("aero-processing") == 1) {
    this.role = "aero-processing";
  }
  if (this.router.url.search("user") == 1) {
    this.role = 'user';
  }
  if (this.router.url.search("pilot") == 1) {
    this.role = 'pilot';
  }
  if (this.router.url.search("super-admin") == 1) {
    this.role = 'super-admin';
  }
  if (this.router.url.search("telstra-processing") == 1) {
    this.role = 'telstra-processing';
  }

    this.route.params.subscribe(params =>{
      this.tower = params.tower;
      this.view = params.view;
      this.loading = false;
      this.crntDir = 0;
      this.index = 0;
      this.prevDir = 0;
      this.sliderIndex = false;
      this.loaded = false;
      this.service.fetchData(this.tower).subscribe(
        (result)=>{
          let temp = {};
                temp = result.data();
        if(this.view === "towerview"){
          this.view = 'TowerView';
           }
           if(this.view === "topdown"){
            this.view = 'TopDown';
           }
           if(this.view === "los"){
            this.view = 'Los';
           }
           this.imageData = temp[this.view];
        },
        (err)=>{
          this.snackBar.open(err, "close", { duration: 2000 });
        },
        ()=>{
        }
      )
    });

  }

  ngOnInit(): void {

  }

  ngAfterViewChecked() {

  }


  setCrntDir(event){
    this.crntDir = event.crntDir;
    this.index = event.index;
  }
    sendIndex(event){
      this.sliderIndex = event.sliderIndex;
      this.index = event.index;
    }

    editDir(event){
        const dialogRef = this.dialog.open(EditComponent, {
          width: '450px',
          maxHeight: '480px',
          data: { name:"Directory", value: event.value }
        });
        dialogRef.afterClosed().subscribe(
          (result) => {
            this.dirValue = result.value;
          },
          err => {
            this.snackBar.open(err, "close", { duration: 2000 });
          },
          () => {
            this.imageData[event.index].Directory = this.dirValue;
            this.updateData();
          })
  }

  updateData(){
    let result = {};
    result[this.view] = this.imageData;
    this.service.setData(this.tower).update(result).catch(err => {
      this.snackBar.open(err, "close", { duration: 2000 });
    })
  }

  loadMsg(){
setTimeout(()=>{this.loaded = true;},2000);
  }

}
